/* ============================================================
   OBEE EXTRACTS — Frontend
   Kein Framework, keine Abhängigkeiten. Läuft in Liquid und
   in der Standalone-Vorschau identisch.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Age Gate ---------- */
  function initGate() {
    var gate = document.getElementById('ageGate');
    if (!gate) return;
    var KEY = 'obee-age-ok';
    var ok;
    try { ok = document.cookie.indexOf(KEY + '=1') > -1 || localStorage.getItem(KEY) === '1'; } catch (e) { ok = false; }

    if (ok) { gate.hidden = true; return; }
    document.body.classList.add('gate-open');

    var yes = document.getElementById('gateYes');
    var no  = document.getElementById('gateNo');

    if (yes) yes.addEventListener('click', function () {
      try {
        localStorage.setItem(KEY, '1');
        var d = new Date(); d.setDate(d.getDate() + 30);
        document.cookie = KEY + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
      } catch (e) {}
      gate.style.opacity = '0';
      gate.style.transition = 'opacity .45s cubic-bezier(.16,1,.3,1)';
      setTimeout(function () { gate.hidden = true; document.body.classList.remove('gate-open'); }, 450);
    });

    if (no) no.addEventListener('click', function () {
      gate.querySelector('.gate-card').innerHTML =
        '<h2>Zugang nicht möglich</h2><p>Dieses Angebot richtet sich ausschließlich an Personen ab 18 Jahren.</p>';
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var h = document.getElementById('siteHeader');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('stuck', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll-Reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rv');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Marquee ---------- */
  function initMarquee() {
    var track = document.getElementById('mqTrack');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    items.forEach(function (n) { track.appendChild(n.cloneNode(true)); });
  }

  /* ---------- Generation 2 Showcase ---------- */
  function initGen2() {
    var root = document.getElementById('gen2');
    if (!root) return;

    var picker = root.querySelector('.gen2-picker');
    var packs  = root.querySelectorAll('.gen2-packs img');
    var nameEl = root.querySelector('[data-gen2-name]');
    var idxEl  = root.querySelector('[data-gen2-idx]');
    var btns   = picker ? picker.querySelectorAll('button') : [];
    if (!packs.length || !btns.length) return;

    var current = 0;
    var timer = null;

    function show(i, userAction) {
      if (i === current && userAction !== 'init') return;
      current = i;
      var btn = btns[i];
      var accent = btn.getAttribute('data-accent') || '#d4a613';
      var name   = btn.getAttribute('data-name') || btn.textContent.trim();

      root.style.setProperty('--accent', accent);

      packs.forEach(function (p, k) { p.classList.toggle('on', k === i); });
      Array.prototype.forEach.call(btns, function (b, k) {
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });

      if (nameEl) nameEl.textContent = name;
      if (idxEl)  idxEl.textContent  = String(i + 1).padStart(2, '0') + ' / ' + String(packs.length).padStart(2, '0');

      // erweiterte Angaben aus dem Datenblatt
      var data = (window.OBEE_STRAINS && window.OBEE_STRAINS.strains) ? window.OBEE_STRAINS.strains[i] : null;
      if (data) {
        var set = function (sel, val) {
          var el = root.querySelector(sel);
          if (el) el.textContent = val || '';
        };
        set('[data-g-full]', data.full);
        set('[data-g-type]', data.type + (data.split ? ' · ' + data.split : ''));
        set('[data-g-gen]',  data.genetics);
        set('[data-g-breed]',data.breeder || '—');
        set('[data-g-p]',    data.primary);
        set('[data-g-s]',    data.secondary);
        set('[data-g-f]',    data.finish);
        var noteEl = root.querySelector('[data-g-note]');
        if (noteEl) { noteEl.textContent = data.note || ''; noteEl.style.display = data.note ? '' : 'none'; }
        var tEl = root.querySelector('[data-g-terp]');
        if (tEl) tEl.innerHTML = (data.terpenes || []).map(function (t) { return '<span>' + t + '</span>'; }).join('');
      }

      /* Das Menü nur waagerecht nachführen. scrollIntoView hätte auch
         die Seite senkrecht verschoben. */
      if (picker && userAction !== 'auto' && userAction !== 'init') {
        picker.scrollTo({
          left: btn.offsetLeft - (picker.clientWidth - btn.offsetWidth) / 2,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }
    }

    Array.prototype.forEach.call(btns, function (b, i) {
      b.addEventListener('click', function () { stop(); show(i, 'click'); });
    });

    /* ---------- Pfeile ----------
       preventDefault und blur, sonst scrollt der Browser den
       angetippten Knopf in den sichtbaren Bereich — auf dem Telefon
       sprang die Seite dadurch nach unten, statt das Bild zu wechseln. */
    function step(d) { stop(); show((current + d + packs.length) % packs.length, 'arrow'); }
    function bind(el, d) {
      if (!el) return;
      el.setAttribute('type', 'button');
      el.addEventListener('click', function (e) {
        e.preventDefault(); step(d); if (el.blur) el.blur();
      });
    }
    bind(root.querySelector('[data-gen2-prev]'), -1);
    bind(root.querySelector('[data-gen2-next]'),  1);

    /* ---------- Wischen ---------- */
    var stage = root.querySelector('.gen2-stage');
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        // Nur waagerechte Gesten, sonst blockieren wir das Scrollen
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.6) step(dx < 0 ? 1 : -1);
        x0 = y0 = null;
      }, { passive: true });
    }

    /* Von der Übersicht aus ansteuerbar */
    window.OBEE_GEN2 = function (i) {
      stop(); show(i, 'click');
      root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    };

    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { show((current + 1) % packs.length, 'auto'); }, 4200);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('touchstart', stop, { passive: true });

    show(0, 'init');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.35 }).observe(root);
    } else { start(); }
  }

  /* ---------- 03 — The Case ----------
     Der Kartonfilm läuft beim Scrollen einmal ab und hält auf dem
     letzten Bild; danach erscheint "Play again". Die zehn Sorten
     stehen als Reihe darunter — von Liquid aus den Blöcken der
     Sektion gerendert, hier nur verdrahtet.

     Ein Klick springt über den SORTENNAMEN (nicht über einen festen
     Index) in "Generation 2" — dessen Reihenfolge kommt aus eigenen,
     im Theme-Editor sortierbaren Blöcken und muss nicht mit der
     Reihenfolge hier übereinstimmen. */
  function initCase() {
    var root = document.getElementById('case');
    if (!root) return;
    var box = root.querySelector('[data-case-box]');
    if (!box) return;
    var film = box.querySelector('video');
    if (!film) return;

    var sel  = root.querySelector('[data-case-sel]');
    var idle = sel ? sel.textContent : '';

    function mark(btn) {
      if (!sel) return;
      if (!btn) {
        sel.textContent = idle; sel.classList.remove('on'); sel.style.removeProperty('--c');
        return;
      }
      var name = btn.getAttribute('data-name') || '';
      var type = btn.getAttribute('data-type') || '';
      sel.innerHTML = '<b>' + name + '</b> — ' + type + ' · 10 devices';
      sel.style.setProperty('--c', btn.style.getPropertyValue('--c') || '#ffffff');
      sel.classList.add('on');
    }

    /* Führt in "Generation 2" — dort stehen die Packungen. Sucht den
       Picker-Button mit demselben Namen und ruft dessen Index auf,
       statt einen Index fest zu verdrahten. */
    function goto(name) {
      if (!window.OBEE_GEN2) return;
      var btns = document.querySelectorAll('#gen2 .gen2-picker button');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('data-name') === name) { window.OBEE_GEN2(i); return; }
      }
    }

    var rail = root.querySelector('.case-strains');
    if (rail) {
      Array.prototype.forEach.call(rail.querySelectorAll('button[data-name]'), function (btn) {
        var target = btn.getAttribute('data-goto') || btn.getAttribute('data-name');
        btn.addEventListener('mouseenter', function () { mark(btn); });
        btn.addEventListener('focus',      function () { mark(btn); });
        btn.addEventListener('click',      function () { goto(target); });
      });
      rail.addEventListener('mouseleave', function () { mark(null); });
    }

    var opened = false, running = false;

    function setLabel(txt) {
      var l = root.querySelector('[data-case-trigger] .lbl');
      if (l) l.textContent = txt;
    }

    function done() {
      box.classList.add('is-open');
      root.classList.add('seen');
      opened = true; running = false;
    }

    function open() {
      if (opened || running) return;
      running = true;
      box.classList.add('is-playing');
      if (reduced) {                        /* nicht abspielen, direkt das Endbild */
        try { film.currentTime = Math.max(0, (film.duration || 8) - 0.05); } catch (e) {}
        box.classList.remove('is-playing'); done(); return;
      }
      film.currentTime = 0;
      var p = film.play();
      if (p && p.catch) p.catch(function () {   /* Autoplay verweigert */
        box.classList.remove('is-playing');
        running = false; film.setAttribute('controls', '');
      });
    }

    function replay() {
      if (running) return;
      opened = false;
      box.classList.remove('is-open');
      mark(null);
      open();
    }

    film.addEventListener('ended', function () {
      box.classList.remove('is-playing');
      done(); setLabel('Play again');
    });
    /* Sicherheitsnetz: bricht die Wiedergabe ab, bleibt der Block
       sonst im Zwischenzustand stehen. */
    film.addEventListener('error', function () {
      box.classList.remove('is-playing'); done();
    });

    box.addEventListener('click', function () { opened ? replay() : open(); });

    var trig = root.querySelector('[data-case-trigger]');
    if (trig) trig.addEventListener('click', function (e) {
      e.stopPropagation();
      opened ? replay() : open();
    });

    /* Tastatur: der Karton ist ohne Maus bedienbar */
    box.setAttribute('tabindex', '0');
    box.setAttribute('role', 'button');
    box.setAttribute('aria-label', 'Open the OBEE EXTRACTS master case');
    box.addEventListener('keydown', function (e) {
      if (e.target !== box) return;           /* nicht auf den Sorten mitfeuern */
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        opened ? replay() : open();
      }
    });

    /* Beim Scrollen einmal von selbst starten */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { setTimeout(open, 120); io.disconnect(); }
        });
      }, { threshold: 0.45 });
      io.observe(box);
    } else { open(); }

    /* CTA: falls diese Seite (wie die Vorschau) ein Handelsformular
       im selben Dokument hat, gleich mit öffnen. Sonst bleibt es ein
       normaler Link — z. B. auf die Händlerseite. */
    var cta = root.querySelector('[data-case-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        var t = document.querySelector('.trade .toggle');
        var p = document.querySelector('.trade-form');
        if (t && p && !p.classList.contains('open')) t.click();
      });
    }
  }

  /* ---------- Newsletter ---------- */
  function initForm() {
    var form = document.getElementById('notifyForm');
    if (!form) return;
    var msg = form.querySelector('.form-msg');

    form.addEventListener('submit', function (ev) {
      var email   = form.querySelector('input[type="email"]');
      var consent = form.querySelector('input[type="checkbox"]');

      if (!email || !email.value || email.value.indexOf('@') < 1) {
        ev.preventDefault();
        if (msg) { msg.className = 'form-msg err'; msg.textContent = 'Bitte gültige E-Mail-Adresse eingeben'; }
        return;
      }
      if (consent && !consent.checked) {
        ev.preventDefault();
        if (msg) { msg.className = 'form-msg err'; msg.textContent = 'Bitte Einwilligung und Alter bestätigen'; }
        return;
      }

      // Ohne Brevo-Endpunkt: lokal bestätigen statt Seite neu zu laden
      if (!form.getAttribute('action')) {
        ev.preventDefault();
        if (msg) { msg.className = 'form-msg ok'; msg.textContent = 'Fast geschafft — bitte E-Mail bestätigen'; }
        form.querySelector('.form-row').style.opacity = '.4';
      }
    });
  }

  function boot() {
    initGate(); initHeader(); initReveal();
    initMarquee(); initGen2(); initCase(); initForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
